import PropTypes from "prop-types";

Main.propTypes = {
    sx: PropTypes.object,
    children: PropTypes.node,
};

export default function Main({ children }) {
    return <div>{children}</div>;
}
